import scopedI18n from '@locale/scoped-i18n';
import {useTranslation} from 'react-i18next';

export const useScopedTranslation = () => {
	return useTranslation(undefined, {i18n: scopedI18n});
};
